import type { ComponentProps, ReactNode } from 'react';
import type { LinkProps } from 'react-router';

import { Link } from 'react-router';
import { Table } from 'rsuite';

import { deepReadKeyValue, getTestProps } from '../../../lib/helpers';

const { Cell } = Table;

const cellClasses =
  'px-4 py-2 h-full w-full flex items-center truncate group select-all ';

export type DataGridGetRowLinkOptionsFn = (
  accessor: string,
  rowData: any,
) => LinkProps | undefined;

interface RowCellProps extends Omit<
  ComponentProps<typeof Cell>,
  'children' | 'renderCell'
> {
  accessor: string;
  renderCell: (value: any, rowData: any) => ReactNode;
  getRowLinkOptions?: DataGridGetRowLinkOptionsFn;
  testId?: string;
}

const RowCell = ({
  accessor,
  renderCell,
  getRowLinkOptions,
  testId,
  ...rest
}: RowCellProps) => {
  const rowData = rest.rowData || {};
  const linkOptions = getRowLinkOptions?.(accessor, rowData);
  const content = renderCell(deepReadKeyValue(accessor, rowData), rowData);

  return (
    <Cell {...rest}>
      {linkOptions ? (
        <Link
          className={
            cellClasses +
            'focus:no-underline hover:no-underline active:no-underline ' +
            'focus:text-slate-900 active:text-slate-900 hover:text-slate-900 ' +
            'dark:hover:text-slate-200 dark:active:text-slate-200'
          }
          {...linkOptions}
          {...getTestProps(testId, `row-${accessor}`)}
        >
          {content}
        </Link>
      ) : (
        <div
          className={cellClasses}
          {...getTestProps(testId, `row-${accessor}`)}
        >
          {content}
        </div>
      )}
    </Cell>
  );
};

export default RowCell;
